import { ExportImport } from "lib/util/exportString";
import lodash from "lodash";
import { identity } from "lodash";
export var QueryLinks;
(function (QueryLinks) {
    let Commands;
    (function (Commands) {
        function invocation(command, arg) {
            let cloned_arg = lodash.clone(arg);
            for (let key of Object.keys(command.serializer)) {
                cloned_arg[key] = (command.serializer[key] || identity)(arg[key]);
            }
            return {
                name: command.name,
                arg: cloned_arg
            };
        }
        Commands.invocation = invocation;
    })(Commands = QueryLinks.Commands || (QueryLinks.Commands = {}));
    let QueryInvocation;
    (function (QueryInvocation) {
        var imp = ExportImport.imp;
        function toQuery(query, compact = true) {
            if (compact)
                return new URLSearchParams({
                    "ctr_query": exp(null, true, false)(query)
                });
            else {
                let encoded = {
                    "ctr_query": query.name,
                };
                for (let key of Object.keys(query.arg)) {
                    let value = query.arg[key];
                    if (typeof value == "string")
                        encoded[key] = value;
                    else
                        encoded[key] = JSON.stringify(value);
                }
                return new URLSearchParams(encoded);
            }
        }
        QueryInvocation.toQuery = toQuery;
        function fromQuery(index, params) {
            let query = params.get("ctr_query");
            if (!query)
                return null;
            if (index.find(c => c.name == query)) {
                return { name: query, arg: Object.fromEntries(params.entries()) };
            }
            else
                return imp()(query);
        }
        QueryInvocation.fromQuery = fromQuery;
        function resolve(index, query) {
            let command = index.find(c => c.name == query.name);
            let cloned_arg = lodash.clone(query.arg);
            for (let key of Object.keys(command.parser)) {
                cloned_arg[key] = query.arg[key] == null
                    ? command.default[key]
                    : (command.parser[key] || imp)(query.arg[key]);
            }
            return command.instantiate(query.arg);
        }
        QueryInvocation.resolve = resolve;
    })(QueryInvocation || (QueryInvocation = {}));
    function link(command, arg, compact = true) {
        return `${get_path()}?${QueryInvocation.toQuery(Commands.invocation(command, arg), compact).toString()}`;
    }
    QueryLinks.link = link;
    function get_from_params(index, parameters) {
        let invocation = QueryInvocation.fromQuery(index, parameters);
        if (!invocation)
            return null;
        return QueryInvocation.resolve(index, invocation);
    }
    QueryLinks.get_from_params = get_from_params;
    var exp = ExportImport.exp;
    function get_path() {
        if (window)
            return window.location.origin + window.location.pathname;
        else
            return "https://cluetrainer.app";
    }
})(QueryLinks || (QueryLinks = {}));
